function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 123 123",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-0.00317043,0.000669724)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1035.47,-865.604)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.140969,0,0,0.140969,889.504,743.58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1469.18,865.604C1708.55,865.604 1902.89,1059.94 1902.89,1299.31C1902.89,1538.68 1708.55,1733.02 1469.18,1733.02C1229.81,1733.02 1035.47,1538.68 1035.47,1299.31C1035.47,1059.94 1229.81,865.604 1469.18,865.604ZM1469.18,910.223C1683.93,910.223 1858.27,1084.57 1858.27,1299.31C1858.27,1514.06 1683.93,1688.4 1469.18,1688.4C1254.44,1688.4 1080.09,1514.06 1080.09,1299.31C1080.09,1084.57 1254.44,910.223 1469.18,910.223Z",
    style: {
      fill: "rgb(46,112,104)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.140969,0,0,0.140969,1074.26,955.818)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(600,0,0,600,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.23,-0.176C0.23,-0.188 0.23,-0.197 0.23,-0.203C0.23,-0.237 0.235,-0.267 0.245,-0.292C0.252,-0.311 0.263,-0.33 0.279,-0.349C0.291,-0.363 0.312,-0.384 0.343,-0.41C0.373,-0.437 0.393,-0.459 0.402,-0.475C0.411,-0.491 0.416,-0.508 0.416,-0.527C0.416,-0.561 0.402,-0.591 0.375,-0.617C0.349,-0.643 0.316,-0.656 0.277,-0.656C0.24,-0.656 0.209,-0.644 0.184,-0.621C0.159,-0.597 0.142,-0.561 0.134,-0.511L0.044,-0.521C0.052,-0.588 0.076,-0.639 0.116,-0.675C0.157,-0.71 0.21,-0.728 0.276,-0.728C0.346,-0.728 0.402,-0.709 0.443,-0.671C0.485,-0.633 0.506,-0.587 0.506,-0.533C0.506,-0.501 0.499,-0.473 0.484,-0.446C0.469,-0.42 0.441,-0.388 0.398,-0.35C0.369,-0.325 0.351,-0.306 0.342,-0.294C0.333,-0.282 0.326,-0.268 0.322,-0.252C0.318,-0.237 0.316,-0.211 0.315,-0.176L0.23,-0.176ZM0.225,-0L0.225,-0.1L0.325,-0.1L0.325,-0L0.225,-0Z",
    style: {
      fill: "rgb(46,112,104)",
      fillRule: "nonzero"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.b885ff89857ac8ed06db16e57ab1b93b.svg";
export { ForwardRef as ReactComponent };